<template>
  <div>
    <!-- https://stackoverflow.com/a/57235465 -->
    <div ref="reference" class="tooltip__reference" v-on="isTouchOnly ? { click: clickHandler } : { mouseenter: open, mouseleave: handleMouseLeave }">
      <slot name="reference">
        Tooltip Reference
      </slot>
    </div>

    <!-- If the tooltip is wrapped with <a>, and we want to have interactive
    content, we want to render the content outisde of that <a>. -->
    <portal to="popper-root">
      <!-- The key is needed so the `ref` gets picked up (https://github.com/LinusBorg/portal-vue/issues/294#issuecomment-666397458) -->
      <div ref="popper" key="popper" class="tooltip__popper" v-on="isTouchOnly ? undefined : { mouseenter: open, mouseleave: handleMouseLeave }">
        <transition name="message">
          <div class="tooltip__content" v-if="isOpen">
            <slot name="content">
              Tooltip
            </slot>
          </div>
        </transition>
      </div>
    </portal>
  
  </div>
</template>

<script>
  import { createPopper } from '@popperjs/core'

  export default {
    name: 'tooltip',

    data () {
      return {
        isOpen: false,
        popper: null,
        isTouchOnly: false,
        closeTimeoutId: null
      }
    },

    mounted () {
      this.resizeHandler()
      window.addEventListener('resize', this.resizeHandler)
      // Init the popper after the DOM was updated so we get the correct refs 
      this.$nextTick().then(() => this.initPopper())
    },

    destroyed () {
      window.removeEventListener('resize', this.resizeHandler)
    },

    computed: {
      getTouchEventHandlers () {
        if (this.isOpen) {
          return { click: this.clickHandler }
        } else {
          return { click: this.clickHandler }
        }
      }
    },

    methods: {
      open () {
        clearTimeout(this.closeTimeoutId);
        this.isOpen = true;
      },
      handleMouseLeave () {
        this.closeTimeoutId = setTimeout(this.close, 150);
      },
      close () {
        this.isOpen = false
      },
      initPopper () {
        if (!this.$refs.reference || !this.$refs.popper) return;

        this.popper = createPopper(this.$refs.reference, this.$refs.popper, {
          placement: 'bottom-end',
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                padding: 15 // Needs to be the same value as `$gutter-container`
              }
            },
            {
              name: 'offset',
              options: {
                offset: [0, 10] // 10px vertical offset
              }
            }
          ]
        });
      },
      resizeHandler () {
        this.isTouchOnly = window.matchMedia("(any-hover: none)").matches
      },
      clickHandler (e) {
        // For instances where tooltip is wrapped in an <a>
        e.preventDefault()
        if (this.isOpen) this.close()
        else this.open()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Tooltip.vue?6b238d26